export function getLanguages() {
    const languages = {};
    const request = new XMLHttpRequest();
    request.open('GET', '/api/v3/public/language', false);
    request.send(null);
    const json = JSON.parse(request.responseText);
    for (const i in json) {
        languages[json[i].key] = json[i].string;
    }
    return languages;
}
